const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.dev.dralia.ayi.group';

export const postToChatAPI = async (prompt: string): Promise<any> => {
    const endpoint = '/api/chat';
    const url = `${API_BASE_URL}${endpoint}`;
    const body = { prompt };

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    });

    if (!response.ok) {
        throw new Error('Network response was not ok');
    }

    return response.json();
};
